import _ from "lodash";
import { 
    addDocumentComment, 
    updateDocumentComment, 
    deleteDocumentComment 
} from 'Source/reducers/project/comments/comments.service';

/**
 * @returns {ThunkAction}
 */
export function initialize({ projectId, document, list, onAddComment=null, source=null }) {
    return (dispatch) => {
        // TODO: this can be presorted already in BE?
        const sortedList = _.sortBy(list, ['dateAdded']).reverse().map(
            comment => {
                if (comment.reply && comment.reply.length) {
                    comment.reply = _.sortBy(comment.reply,['dateAdded']).reverse();
                }

                return comment;
            }
        );

        dispatch({type: "COMMENTS_SET_DOCUMENT", document: document });
        dispatch({type: "COMMENTS_SET_PROJECT_ID", projectId: projectId });
        dispatch({type: "COMMENTS_SET_ON_ADD_COMMENT", onAddComment: onAddComment });
        dispatch({type: "COMMENTS_SET_SOURCE", source });
        dispatch(updateList(sortedList));
        dispatch(updateListCount(sortedList.length));
    }
}

/**
 * @param {array} list
 * 
 * @returns {ThunkAction}
 */
export function updateList(list) {
    return (dispatch) => {
        dispatch({type: "COMMENTS_UPDATE_LIST", list: list });
    }
}

export function updateListCount(totalCount) {
    return (dispatch) => {
        dispatch({type: "COMMENTS_UPDATE_LIST_COUNT", totalCount: totalCount});
    }
}

/**
 * @param {String} list
 * 
 * @returns {ThunkAction}
 */
export function addCommentToList(comment) {
    return (dispatch, getState) => {
        const state = getState();
        let list = state.comments.list.list;
        const newList = [
            comment,
            ...list
        ];

        dispatch(updateList(newList));
        dispatch(updateListCount(newList.length));
    }
}

/**
 * @param {String} list
 * 
 * @returns {ThunkAction}
 */
export function updateCommentInList(comment) {
    return (dispatch, getState) => {
        const state = getState();
        let newList = [...state.comments.list.list];
        const index = _.findIndex(newList, { id: comment.id });

        if(index >= 0) {
            newList.splice(index, 1, {...newList[index], ...comment});
        } 

        dispatch(updateList(newList));
    }
}

/**
 * @param {String} list
 * 
 * @returns {ThunkAction}
 */
export function updateCommentReplyInList(comment, replyToId) {
    return (dispatch, getState) => {
        const state = getState();
        let newList = [...state.comments.list.list];
        const index = _.findIndex(newList, { id: replyToId });

        if(index >= 0) {
            const commentReply = newList[index];
            const replyIndex = _.findIndex(commentReply.reply, { id: comment.id });

            newList[index].reply.splice(replyIndex, 1, {...commentReply.reply, ...comment});
        } 

        dispatch(updateList(newList));
    }
}

/**
 * @param {String} commentStr
 * @param {Number} replyTo
 * 
 * @returns {ThunkAction}
 */
export function addCommentFromApi(commentStr, replyTo) {
    return (dispatch, getState) => {
        const state = getState();
        let { comments }= state;
        const loggedUser = state.loggedUser;
        const { projectId, document, source } = comments;

        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

        return addDocumentComment({
            commentStr, 
            document, 
            projectId, 
            loggedUser, 
            replyTo,
            source,
        }).then(response => {
            if(response) {
                if (replyTo) {
                    dispatch(updateCommentInList(response.data.result));
                } else {
                    dispatch(addCommentToList(response.data.result));
                }

                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
            }

            return response;
        });
    }
}

/**
 * @param {Number} commentId
 * @param {String} commentStr
 * 
 * @returns {ThunkAction}
 */
export function updateCommentFromApi(commentId, commentStr) {
    return (dispatch, getState) => {
        const state = getState();
        const comments = state.comments.list.list;
        const source = state.comments.source;

        return updateDocumentComment({
            commentId, 
            commentStr,
            source
        })
        .then(response => {
            if(response.data.commentGroup) {
                const newComments = comments.map(c=>{
                     c.reply =  (c.reply || []).map(r=>{
                        if(r.id === response.data.id) {
                            return response.data
                        }
                        return r
                    })
                 
                    return c
                })

                dispatch(updateList(newComments));
             } else {
                const newComment = {
                    ...response.data, 
                    isUpdating: 0, 
                    previousComment: response.data.comment
                };

                dispatch(updateCommentInList(newComment));
             }

             return response;
        });
    }
}

/**
 * @param {Number} commentId
 * @param {Number} replyToId
 * 
 * @returns {ThunkAction}
 */
export function deleteCommentFromApi(commentId, replyToId) {
    return (dispatch) => {
        return deleteDocumentComment(commentId)
        .then(response => {
            const newComment = response.data;
            
            if (replyToId) {
                dispatch(updateCommentReplyInList(newComment, replyToId));
            } else {
                dispatch(updateCommentInList(newComment));
            }

            return response;
        });
    }
}

